var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"weje-logo",attrs:{"to":"/"}},[_c('svg',{attrs:{"height":"28","width":"88"}},[_c('use',{attrs:{"xlink:href":require("@/assets/logo.svg") + "#logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }